import React from 'react';
import { useEvents } from '../context/EventsContext';
import { getMinecraftItemIcon, formatEventDate, getRelativeTime, renderMinecraftTextHTML } from '../utils/minecraftIcons';
import './EventsPage.css';

// Helper to clean description (replace /n with space)
function cleanDescription(text) {
  if (!text) return null;
  return text
    .split('/n').join(' ')
    .split('\\n').join(' ')
    .split('\n').join(' ');
}

export default function EventsPage() {
  const { events, loading, error, lastUpdated } = useEvents();

  return (
    <section className="events-page">
      <div className="events-header">
        <div className="container">
          <h1 className="events-title animate-slide-up">Upcoming Events</h1>
          <p className="events-subtitle animate-slide-up delay-1">
            Join our community events and compete for glory!
          </p>
        </div>
      </div>

      <div className="events-container">
        {loading ? (
          <div className="events-loading">
            <div className="loading-spinner"></div>
            <p>Loading events...</p>
          </div>
        ) : error ? (
          <div className="events-error">
            <p>Unable to load events. Please try again later.</p>
          </div>
        ) : events.length === 0 ? (
          <div className="events-empty">
            <div className="empty-icon">
              <i className="mdi mdi-calendar-blank"></i>
            </div>
            <h2>No Upcoming Events</h2>
            <p>Check back soon or join our Discord to be notified of new events!</p>
            <a
              href="https://discord.thetopia.net"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-large"
            >
              <i className="mdi mdi-discord"></i> Join Discord
            </a>
          </div>
        ) : (
          <div className="events-list">
            {events.map((event, index) => (
              <div
                key={event.id || index}
                className="event-item"
              >
                <div className="event-item-icon">
                  <img
                    src={getMinecraftItemIcon(event.item)}
                    alt=""
                    onError={(e) => {
                      e.target.src = '/logo.png';
                    }}
                  />
                </div>
                <div className="event-item-content mc-tooltip-large">
                  <div className="event-item-header">
                    <span className="event-server-tag">{event.server || 'TheTopia'}</span>
                    <span className="event-countdown mc-text-green">
                      {getRelativeTime(event.timestamp)}
                    </span>
                  </div>
                  <h2
                    className="event-item-title mc-text"
                    dangerouslySetInnerHTML={{ __html: renderMinecraftTextHTML(event.name) }}
                  />
                  <p className="event-item-description mc-lore-gray">{cleanDescription(event.description)}</p>
                  <div className="event-item-datetime mc-text-white">
                    <i className="mdi mdi-calendar"></i>
                    <span>{formatEventDate(event.timestamp)}</span>
                  </div>
                  {event.voicechat && (
                    <div className="event-voicechat-badge">
                      <i className="mdi mdi-microphone"></i>
                      <span>Voice Chat Required</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {lastUpdated && (
          <p className="events-last-updated">
            Last updated: {new Date(lastUpdated).toLocaleTimeString()}
          </p>
        )}
      </div>
    </section>
  );
}
